import { useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import {
  exchangeCodeForToken,
  processTokenResponse,
  consumeAuthReturnPath,
  type TokenResult,
} from "@/lib/auth/authService";

export function LoginCallbackPage() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;

    let code: string | null = null;
    let accessToken: string | null = null;
    let idToken: string | null = null;
    let error: string | null = null;
    let expiresIn: number | undefined;

    if (window.location.hash) {
      const hash = new URLSearchParams(window.location.hash.substring(1));
      code = hash.get("code");
      accessToken = hash.get("access_token");
      idToken = hash.get("id_token");
      error = hash.get("error");
      const exp = hash.get("expires_in");
      if (exp) expiresIn = parseInt(exp, 10);
    }

    if (!code && !accessToken && !error) {
      const search = new URLSearchParams(window.location.search);
      code = search.get("code");
      error = search.get("error");
    }

    if (error) {
      window.location.href = consumeAuthReturnPath("/dashboard");
      return;
    }

    if (accessToken || code) {
      processed.current = true;
      void (async () => {
        try {
          if (accessToken) {
            const partial: TokenResult = {
              access_token: accessToken,
              id_token: idToken ?? undefined,
              expires_in: expiresIn,
            };
            processTokenResponse(partial);
          }
          if (code) processTokenResponse(await exchangeCodeForToken(code));
          window.location.href = consumeAuthReturnPath("/dashboard");
        } catch {
          window.location.href = "/dashboard";
        }
      })();
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        bgcolor: "#e8ecf1",
        color: "#121926",
      }}
    >
      <CircularProgress size={56} />
      <Typography sx={{ mt: 2, fontSize: "1.25rem", fontWeight: 600 }}>
        Completing login…
      </Typography>
    </Box>
  );
}
